import '../../scss/pages/join.scss';

var $ = require('jquery');
window.jQuery = $;
window.$ = $;

$( document ).ready(function() {
	$('.accordion-manual').slideUp();

	$('.btn-open-accordion-manual').on('click', function(evt) {
		if ($('.accordion-manual').hasClass('opened')) {
			$('.accordion-manual').slideUp().removeClass('opened');
			$(this).html('Show More');
		}
		else {
			$('.accordion-manual').slideDown().addClass('opened');
			$(this).html('Show Less');
		}
	});

	$('#primary-menu a').click(function(e) {
        var target_scroll_id = $(this).attr('href');
        var target_scroll_offset = $(target_scroll_id).offset();
        var scroll_distance = target_scroll_offset.top;
		var gap = $(window).width() < 992 ? 650 : 100;

		// Close Bootstrap collapse menu on mobile
		$('#navbarText').collapse('hide');
		$('.navbar-toggler').attr('aria-expanded', 'false');
		
        $('html, body').animate({
            scrollTop: scroll_distance - gap
        }, 500);
        e.preventDefault();
    });

    // Hover height animation for legacy cards only; video cards use CSS hover
    $('.container-curriculum .card:not(.card-has-video)').on('mouseenter', function(e) {
    	var $card = $(this);
    	var $cardText = $card.find('.card-text');
    	
    	// Get current height
    	var currentHeight = $card.outerHeight();
    	
    	// Temporarily show description to measure full height
    	$cardText.addClass('hover-active');
    	var newHeight = $card.outerHeight();
    	
    	// Set explicit height for animation
    	$card.css({
    		'height': currentHeight + 'px',
    		'transition': 'height 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    	});
    	
    	// Trigger reflow
    	$card[0].offsetHeight;
    	
    	// Animate to new height
    	setTimeout(function() {
    		$card.css('height', newHeight + 'px');
    	}, 10);
    }).on('mouseleave', function(e) {
    	var $card = $(this);
    	var $cardText = $card.find('.card-text');
    	
    	// Get current height
    	var currentHeight = $card.outerHeight();
    	
    	// Hide description to measure collapsed height
    	$cardText.removeClass('hover-active');
    	var newHeight = $card.outerHeight();
    	
    	// Set explicit height for animation
    	$card.css('height', currentHeight + 'px');
    	
    	// Trigger reflow
    	$card[0].offsetHeight;
    	
    	// Animate to new height
    	setTimeout(function() {
    		$card.css('height', newHeight + 'px');
    		
    		// Reset to auto after animation completes
    		setTimeout(function() {
    			$card.css({
    				'height': '',
    				'transition': ''
    			});
    		}, 400);
    	}, 10);
    });

    // Legacy dropdown toggle handler - kept for backward compatibility if needed
    $('.container-curriculum .dropdown-toggle').on('click', function(e) {
    	e.preventDefault();
    	e.stopPropagation();

    	$('.container-curriculum .dropdown-toggle').removeClass('active');
    	$('.container-curriculum .dropdown-menu').removeClass('active');
		var href = $(this).attr('href');

    	$(this).addClass('active');
    	$(href).addClass('active');
    });

    $('.row-payment-float .btn-close').on('click', function(evt) {
    	$(this).parents('.row-payment-float').remove();
    });

    var curriculumVideoModal = document.getElementById('curriculum-video-modal');
    var heroWall = document.querySelector('[data-hero-wall]');
    if (curriculumVideoModal) {
    	var curriculumVideoIframe = curriculumVideoModal.querySelector('.js-wistia-video-iframe');

    	curriculumVideoModal.addEventListener('show.bs.modal', function(event) {
    		var trigger = event.relatedTarget;
    		if (heroWall) {
    			heroWall.classList.add('is-paused');
    		}
    		if (!trigger || !curriculumVideoIframe) {
    			return;
    		}

    		var wistiaId = trigger.getAttribute('data-wistia-id');
    		var videoTitle = trigger.getAttribute('data-wistia-title') || 'Video';

    		if (!wistiaId) {
    			return;
    		}

    		curriculumVideoIframe.src = 'https://fast.wistia.net/embed/iframe/' + wistiaId + '?web_component=true&seo=false&autoPlay=true';
    		curriculumVideoIframe.title = videoTitle;
    	});

    	curriculumVideoModal.addEventListener('hidden.bs.modal', function() {
    		if (heroWall) {
    			heroWall.classList.remove('is-paused');
    		}
    		if (curriculumVideoIframe) {
    			curriculumVideoIframe.src = '';
    			curriculumVideoIframe.title = '';
    		}
    	});
    }

});

// get the sticky element
const stickyElm = document.querySelector('.position-sticky.row-payment');

const observer = new IntersectionObserver( 
  ([e]) => e.target.classList.toggle('show', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(stickyElm);

